import axios from 'axios';

export const verificarAccesoGuiones = async (rut, token) => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_URL_APP}acceso-guiones/${rut}`,
    headers: {
      Authorization: 'Bearer ' + token,
    },
  };

  const response = await axios(config);
  
  return response.data;
};


export const validarAccesoGuiones = async ({ rut, token, navigate }) => {
 try {
   const data = await verificarAccesoGuiones(rut, token);
   if (!data.autorizado) {
     alert('No tienes permisos para acceder a la generación de guiones');
     navigate('/');
     return false;
   }
   return true;
  } catch (error) {
   console.error('Error al validar acceso a guiones:', error);
   navigate('/');
   return false;
  }
};

